import { render, staticRenderFns } from "./overviewSkrg.vue?vue&type=template&id=6ae6fdf9&scoped=true"
import script from "./overviewSkrg.vue?vue&type=script&lang=js"
export * from "./overviewSkrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae6fdf9",
  null
  
)

export default component.exports